export default __webpack_public_path__ + "static/media/saude-sono-mobile.2bbe8d25.png";